export default class {
  constructor() {
    this.hostName = 'c.haitan.shop';
  }
  getEnv() {
    // 生产
    if (location.hostname === this.hostName) {
      return 'pro';
    }
    // 预生产
    if (location.hostname === `pre.${this.hostName}`) {
      return 'pre';
    }
    // 测试
    if (location.hostname === `tes.${this.hostName}`) {
      return 'tes';
    }
    // 开发
    return 'dev';
  }
}
